import type { TAiCreditRateVersion } from '@confinion/confideck-shared';

export type CreditRateVersion = TAiCreditRateVersion;

type AiCreditMode = keyof CreditRateVersion['rates'];

export type PriceCategory = Readonly<{
  id: string;
  label: string;
  creditsPerMillionTokens: number;
}>;

export const toPriceCategories = (rateVersion: CreditRateVersion, aiMode: AiCreditMode): readonly PriceCategory[] => [
  {
    id: 'short-context-input',
    label: 'Short-context input',
    creditsPerMillionTokens: rateVersion.rates[aiMode].short.inputCreditsPerMillion,
  },
  {
    id: 'short-context-output',
    label: 'Short-context output',
    creditsPerMillionTokens: rateVersion.rates[aiMode].short.outputCreditsPerMillion,
  },
  {
    id: 'long-context-input',
    label: 'Long-context input',
    creditsPerMillionTokens: rateVersion.rates[aiMode].long.inputCreditsPerMillion,
  },
  {
    id: 'long-context-output',
    label: 'Long-context output',
    creditsPerMillionTokens: rateVersion.rates[aiMode].long.outputCreditsPerMillion,
  },
];
